export const CharityIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <g>
        <path
          d="M3.5985 20.952L3.3325 20.7525H3H0.9975V14.4975H4.13886L8.36142 18.0163L8.63885 18.2475H9H13.5H13.7649L13.9949 18.1161L20.0231 14.6714C21.3507 13.9128 23.0025 14.8713 23.0025 16.4004C23.0025 17.0662 22.6697 17.688 22.1157 18.0573L14.698 23.0025H6.3325L3.5985 20.952Z"
          strokeWidth="1.995"
        />
        <path
          d="M4.46704 14.4953H8.45519C9.64866 14.4953 10.7933 14.9694 11.6372 15.8133L13.793 17.9691"
          strokeWidth="1.995"
        />
        <path
          d="M11.5438 1.85135L12 2.08597L12.4562 1.85135L13.3703 1.38122C13.862 1.12839 14.4024 0.9975 14.9493 0.9975H15.2143C17.004 0.9975 18.5025 2.49783 18.5025 4.40816C18.5025 6.18674 17.6881 7.85222 16.3193 8.90816L12 12.2402L7.68071 8.90816C6.3119 7.85222 5.4975 6.18673 5.4975 4.40816C5.4975 2.49783 6.99599 0.9975 8.78571 0.9975H9.05072C9.59756 0.9975 10.138 1.12839 10.6297 1.38122L11.5438 1.85135Z"
          strokeWidth="1.995"
        />
      </g>
    </svg>
  );
};
